<template>
  <div class="table_wrap">
    <el-table
      class="list-table"
      header-cell-class-name="list-header"
      :data="memberData"
      style="width: 100%"
      height="695"
      empty-text="데이터가 없습니다."
    >
      <el-table-column
        class="table_no"
        type="index"
        label="No"
        min-width="70"
        class-name="num text-center"
        :index="tableIdx"
      >
      </el-table-column>
      <el-table-column label="아이디 유형" width="150" class-name="text-center">
        <template slot-scope="scope">
          <span>
            {{ checkMemberType(scope.row.Social) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="아이디"
        width=""
        class-name="text-center"
        prop="mb_id"
      ></el-table-column>
      <el-table-column
        label="닉네임"
        width=""
        class-name="text-center"
        prop="mb_nick"
      ></el-table-column>
      <el-table-column label="회원가입일" min-width="" class-name="text-center">
        <template slot-scope="scope">
          <span>
            {{ returnDateFormat(scope.row.created_at, "YYYY-MM-DD HH:mm") }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="옵션" width="85" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info">

              <el-button class="com_search" @click="selectMember(scope.row)"
                                   v-if="returnCheck(scope.row.mb_no)" :disabled="setNotSsamsData(scope.row)">
              선택
            </el-button>
            <el-button class="reg_btn_out" v-else> 선택완료 </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import memberUtil from "@/components/member/memberUtil";
import dateMixins from "@/mixins/dateMixins";
export default {
  name: "MemberListModalLayout",
  mixins: [memberUtil, dateMixins],
  inject: ["memberListSetData", "runSelectMember", "checkSelect"],
  components: {},
  provide() {
    return {};
  },
  props: {
    memberData: { default: () => [] },
    paginationData: {
      default: () => {
        return { total: 0, page: 0, size: 0 };
      },
    },
    ssamsType: ''
  },
  data() {
    return {
      selectArr: [],
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  methods: {
    setNotSsamsData(data){
      if(!util.isEmpty(data) && this.ssamsType == "ssamsCreate" && data.Ssams.status == false){
        return false
      } else {
        return true
      }
    },
    tableIdx(index) {
      return (
        this.paginationData.total -
        index -
        (this.paginationData.page - 1) * this.paginationData.size
      );
    },
    checkMemberType(social) {
      if (social === "Email") {
        return this.returnMemberType(social);
      } else {
        return this.returnMemberType(social.social_type);
      }
    },
      returnCheck(key) {
        return this.checkSelect(key)
    },
    selectMember(member) {
        this.runSelectMember(member)
    },
  },
  watch: {},
};
</script>

<style scoped></style>
